// this is an autogenerated file from App/Account/EmbeddableCoreMessageListener/PaymentsCreateClaim/Charges/Charge/Type/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_EmbeddableCoreMessageListener_PaymentsCreateClaim_Charges_Charge_Type($location_id: uuid!) {
  vaxiom_misc_fee_charge_templates(
    where: {
      organization: { _id: { _eq: $location_id } }
      is_included_in_insurance_claim: { _eq: true }
    }
    order_by: { name: asc_nulls_last }
  ) {
    id
    name
    price
    is_included_in_insurance_claim
    affecting_production_report
    insurance_code_id
    requires_tooth_details
    insurance_code {
      id
      code
      title
    }
  }
}

`